/**
 * The page's title and description as the visitor moves around (REQ-WEB-038, D31).
 *
 * The web server already sends the right tags for whatever address is opened
 * (web/meta.js); this keeps them right after in-page navigation, so the tab,
 * history and bookmarks name the page actually showing. The fixed pages' words
 * come from page-meta.json, the same file the server reads.
 */
import META from "./page-meta.json";
import { lensName } from "./format";

type Fixed = keyof typeof META.pages;

export function setPageMeta(title: string, description?: string): void {
  document.title = title;
  if (description === undefined) return;
  document.querySelector('meta[name="description"]')?.setAttribute("content", description);
}

export function setFixedPageMeta(key: Fixed): void {
  const p = META.pages[key];
  setPageMeta(p.title, p.description);
}

/** "Sony FE 24-70mm F2.8 GM II (Sony E) — lens-specs", as the server's /pages/lens says it. */
export function lensTitle(maker: string, model: string, mount: string): string {
  return `${lensName(maker, model)} (${mount}) — lens-specs`;
}
